/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Brand, MetaEvent } from './types';

const keysPixel: Record<Brand, string> = {
  cp: '328658652481268',
  ac: '548188292029786',
};

const standardMetaEvents = ['Purchase'];

function formatCustomMetaPayload(payload: Record<string, unknown>): Record<string, string | number> {
  return Object.keys(payload ?? {}).reduce((acc: any, curr: any) => {
    if (!['string', 'number'].includes(typeof payload[curr])) {
      acc[curr.replaceAll('.', '_')] = '';
    } else {
      acc[curr.replaceAll('.', '_')] = payload[curr];
    }
    return acc;
  }, {});
}

const sendPurchaseEventToBridge = (event: MetaEvent): void => {
  if (!event.payload) return;

  const value = event.payload.value || 0;

  const nativeParameters: Record<string, any> = {};
  const keyMappings: Record<string, string> = {
    currency: 'fb_currency',
    content_ids: 'fb_content_id',
    content_type: 'fb_content_type',
    content_name: 'fb_content_name',
    order_id: 'fb_order_id',
    num_items: 'fb_num_items',
  };

  for (const key in event.payload) {
    if (key === 'value') continue;

    const nativeKey = keyMappings[key] || key;
    const payloadValue = event.payload[key];

    if (key === 'content_ids' && Array.isArray(payloadValue)) {
      nativeParameters[nativeKey] = JSON.stringify(payloadValue);
    } else {
      nativeParameters[nativeKey] = payloadValue;
    }
  }

  // @ts-ignore
  window.bridge.analyticsFacebookLogEvent(event.eventName, value, nativeParameters);
};

export const useMetaAnalytics = () => {
  const sendEventToMeta = (event: MetaEvent) => {
    const currentBrand = import.meta.env.VITE_ACP_APP_NAME as Brand;
    if (!currentBrand) {
      console.warn('Meta Analytics: Current brand not recognized.');
      return;
    }
    const pixelId = keysPixel[currentBrand];

    // @ts-ignore
    if (window.bridge && window.bridge.isWebViewBridgeAvailable) {
      // Events standard (ex: Purchase)
      if (standardMetaEvents.includes(event.eventName) && event.payload) {
        if (event.eventName === 'Purchase') {
          sendPurchaseEventToBridge(event);
          return;
        }
      } else {
        const formattedPayload = formatCustomMetaPayload(event.payload ?? {});

        if (Object.keys(formattedPayload).length > 0) {
          // @ts-ignore
          window.bridge.analyticsFacebookLogEvent(event.eventName, formattedPayload);
        } else {
          // @ts-ignore
          window.bridge.analyticsFacebookLogEvent(event.eventName, {});
        }
      }
    }

    const resolvedEventName = event.eventName === 'Custom' ? event.payload?.eventName : event.eventName;

    // @ts-ignore
    if (typeof fbq === 'function') {
      // @ts-ignore
      fbq('trackSingleCustom', pixelId, resolvedEventName, event.payload);
    }
  };

  const trackMeta = (event: MetaEvent): void => {
    sendEventToMeta(event);
  };

  return { trackMeta };
};
